import {Resource} from "./resource";
import {TaskState} from "./taskState";

export interface ConfigureLetsEncryptArguments {
    DnsName: string;
    RegistrationEmailAddress: string;
    AcceptLetsEncryptTermsOfService: boolean;
    HttpsPort: number;
    IPAddress: string;
    Path: string;
}

export interface UpdateCalamariTaskArguments {
    MachineIds: string[];
}

export interface UpgradeTaskArguments {
    EnvironmentId?: string;
    MachineIds?: string[];
}

export interface HealthCheckTaskArguments {
    EnvironmentId?: string;
    MachinePolicyId?: string;
    MachineIds?: string[];
    Timeout?: string;
    MachineTimeout?: string;
    OnlyTestConnection: boolean;
}

export enum TaskName {
    Backup = "Backup",
    Deploy = "Deploy",
    Health = "Health",
    AdHocScript = "AdHocScript",
    AutoDeploy = "AutoDeploy",
    ConfigureLetsEncrypt = "ConfigureLetsEncrypt",
    Upgrade = "Upgrade",
    TestEmail = "TestEmail",
    TestAzureAccount = "TestAzureAccount",
    Retention = "Retention",
    Delete = "Delete",
    SystemIntegrityCheck = "SystemIntegrityCheck",
    SyncCommunityActionTemplates = "SyncCommunityActionTemplates",
    SynchronizeBuiltInPackageRepositoryIndex = "SynchronizeBuiltInPackageRepositoryIndex",
    SynchronizeExternalSecurityGroupsForUsers = "SynchronizeExternalSecurityGroupsForUsers",
    UpdateCalamari = "UpdateCalamari",
    Subscription = "Subscription",
    MigrationSpacePartialExport = "MigrationSpacePartialExport",
    MigrationSpaceImport = "MigrationSpaceImport"
}
export interface TaskResource<TArguments = any> extends Resource {
    Name: TaskName;
    Description: string;
    Arguments: TArguments;
    State: TaskState;
    Completed?: string;
    QueueTime?: string;
    QueueTimeExpiry?: string;
    StartTime?: string;
    LastUpdatedTime?: string;
    CompletedTime?: string;
    ServerNode?: string;
    Duration?: string;
    ErrorMessage?: string;
    HasBeenPickedUpByProcessor?: boolean;
    IsCompleted: boolean;
    FinishedSuccessfully?: boolean;
    HasPendingInterruptions: boolean;
    CanRerun?: boolean;
    HasWarningsOrErrors: boolean;
}

export default TaskResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/taskResource.ts